<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'Y' ||
            row.orderStatus === 'P' ||
            row.orderStatus === 'C'
              ? 'success'
              : row.orderStatus === 'S'
              ? 'warning'
              : row.orderStatus === 'D' ||
                row.orderStatus === 'R' ||
                row.orderStatus === 'T'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i class="el-icon-view tool-btn" @click="openDetailPage(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_generate_process') || '生成工艺单'"
            placement="top"
          >
            <i class="el-icon-s-order tool-btn" @click="createProcess(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openDetailPage({ orderCode, orderNo }) {
      this.$router.push({
        name: 'technology-pendingOrder-detail',
        params: { orderCode, orderNo },
      })
    },
    createProcess({ orderCode, orderNo, productLine }) {
      this.$router.push({
        name: 'technology-processSheet-detail',
        params: { orderNo, orderCode, productLine, pageType: 'add' },
      })
    },
  },
}
</script>
